import { useEffect } from 'react'
import ReactConfetti from 'react-confetti'
import { useProjectStore } from 'store/useProjectStore'

export const Confetti = () => {
  const { showConfetti, setShowConfetti } = useProjectStore()

  useEffect(() => {
    if (showConfetti) {
      const timer = setTimeout(() => setShowConfetti(false), 8000)
      return () => clearTimeout(timer)
    }
  }, [showConfetti, setShowConfetti])

  return (
    <ReactConfetti
      width={typeof window !== 'undefined' ? window.innerWidth : 800}
      height={typeof window !== 'undefined' ? window.innerHeight : 600}
      confettiSource={{
        x: 0,
        y: -500,
        w: typeof window !== 'undefined' ? window.innerWidth : 800,
        h: typeof window !== 'undefined' ? window.innerHeight : 600,
      }}
      numberOfPieces={1000}
      gravity={-0.5}
      wind={0.5}
      recycle={false}
      initialVelocityY={-100}
      run={showConfetti}
    />
  )
}
